<ng-container *ngIf="pairingDevicePageData$ | async as pairingDevicePageData">
  <app-card-pairing
    [withBackToLink]="true"
    *ngIf="pairingDevicePageData.isLoggedIn" />
  <app-card-login *ngIf="!pairingDevicePageData.isLoggedIn" />
</ng-container>
